import styled from "styled-components";

export const ErrorpageStyles = styled.div`
  display: flex;
  text-align:center;
  justify-content:center;
  align-items:center;
  margin-top:4em;
`